module.exports = __webpack_public_path__ + "img/React.876a8325.svg";